import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonImagesComponent } from './common-images.component';

const routes: Routes = [{ path: '', component: CommonImagesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommonImagesRoutingModule { }
